import { render, staticRenderFns } from "./SolicitudTableComponent.vue?vue&type=template&id=11a6ba23&"
import script from "./SolicitudTableComponent.vue?vue&type=script&lang=js&"
export * from "./SolicitudTableComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports